// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"3d6bf896","171":"7f083103","581":"59faeee1","760":"d2da4ede","913":"d66c5236"}[chunkId] + ".chunk.js";
};